import { render, staticRenderFns } from "./PromoMaterialsCarousel.vue?vue&type=template&id=67252acd&scoped=true&"
import script from "./PromoMaterialsCarousel.vue?vue&type=script&lang=js&"
export * from "./PromoMaterialsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PromoMaterialsCarousel.vue?vue&type=style&index=0&id=67252acd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67252acd",
  null
  
)

export default component.exports